import type { Organisation, SubscriptionDetails, SubscriptionPlanType } from "types/organisation";
import { SubscriptionStatus } from "types/organisation";

class CheckoutHelpers {
  static sensorEligiblePlanTypes: readonly SubscriptionPlanType[] = Object.freeze([
    "Base",
    "Core",
    "HighSchools",
    "HyroxT2",
    "Program",
    "HighSchoolsProgram",
  ] as const);

  static hasSensorEligiblePlan(subscriptionDetails: SubscriptionDetails | null | undefined): boolean {
    if (!subscriptionDetails) return false;
    return CheckoutHelpers.sensorEligiblePlanTypes.includes(subscriptionDetails.planType);
  }

  static canCreateSensorCheckout(
    organisation: Pick<Organisation, "stripeCustomerId" | "subscriptionDetails"> | null | undefined
  ): boolean {
    if (!organisation?.stripeCustomerId) return false;

    const { subscriptionDetails } = organisation;
    if (!subscriptionDetails) return false;
    if (subscriptionDetails.status !== SubscriptionStatus.Active) return false;

    return CheckoutHelpers.hasSensorEligiblePlan(subscriptionDetails);
  }
}

export default CheckoutHelpers;
